import { isDevelopmentAppEnv } from "@/lib/app-env";

/**
 * When `true`, the “must change password” flow is allowed outside local dev (staging / production).
 * Set in Vercel (or `.env`) for the environments where you want it: same name on server and client.
 *
 * @see https://nextjs.org/docs/app/building-your-application/configuring/environment-variables#bundling-environment-variables-for-the-browser
 */
const ENV_KEY = "NEXT_PUBLIC_UNILYTICS_PASSWORD_CHANGE_ENFORCED" as const;

export function isPasswordChangeEnforcementUnlockedByEnv(): boolean {
	return process.env[ENV_KEY] === "true";
}

/**
 * Server & CLI: may set `users.must_change_password` and return audit events.
 * - **Local dev:** on when `getAppEnv()` is `development` (default; no extra env).
 * - **Any other tier:** set `NEXT_PUBLIC_UNILYTICS_PASSWORD_CHANGE_ENFORCED=true` in that environment.
 */
export function isPasswordChangeEnforcementEnabled(): boolean {
	return isPasswordChangeEnforcementUnlockedByEnv() || isDevelopmentAppEnv();
}

/**
 * Client: redirect users with `mustChangePassword` to the account page.
 * Matches server enablement: env unlocks prod/staging; `NODE_ENV === "development"` covers local without env.
 */
export function shouldEnforcePasswordChangeRedirectClient(): boolean {
	if (isPasswordChangeEnforcementUnlockedByEnv()) {
		return true;
	}
	if (process.env.NODE_ENV === "development") {
		return true;
	}
	return false;
}

export function requiredPasswordChangeEnvVarName(): typeof ENV_KEY {
	return ENV_KEY;
}
